import { defineMessages } from 'react-intl';

export const i18n: {
	positionFilterFocusAreaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterFocusAreaPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterFocusAreaLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterFocusAreaLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	positionFilterFocusAreaLabel: {
		id: 'search-page.filters.names.positionFocusArea',
		defaultMessage: 'Focus area',
		description: 'Label for filtering by content focus area',
	},
	positionFilterFocusAreaPlaceholder: {
		id: 'search-page.talent.filter.focus-area.content.placeholder',
		defaultMessage: 'Find focus areas',
		description: 'Placeholder for content filter search input',
	},
	positionFilterFocusAreaLabelSelected: {
		id: 'search-page.talent.filter.focus-area.content.selected',
		defaultMessage: 'Selected',
		description: 'Focus filter content selected',
	},
	positionFilterFocusAreaLabelUnselected: {
		id: 'search-page.talent.filter.focus-area.content.unselected',
		defaultMessage: 'Suggested',
		description: 'Focus filter content unselected',
	},
});
